/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Marketing_Text_CsInputs */

const cs_form_marketing_text_cs = /** @type {(inputs: Form_Marketing_Text_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketingový text (CS)`)
};

const en_form_marketing_text_cs = /** @type {(inputs: Form_Marketing_Text_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketing text (CS)`)
};

/**
* | output |
* | --- |
* | "Marketing text (CS)" |
*
* @param {Form_Marketing_Text_CsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_marketing_text_cs = /** @type {((inputs?: Form_Marketing_Text_CsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Marketing_Text_CsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_marketing_text_cs(inputs)
	return cs_form_marketing_text_cs(inputs)
});